import React from 'react';
import styled, { css } from 'styled-components';

import theme from '../constants/theme'; // Required instead of using theme provider from styled components due to it being rendered outside the top level ThemeProvider

const baseStyles = css`
  border: 2px solid transparent;
  border-radius: ${theme.borderRadius};
  cursor: pointer;
  display: block;
  font-size: 1rem;
  margin: 0;
  padding: 0.75rem 1rem;
  text-decoration: none;
  outline: none;
  width: auto;
  white-space: nowrap;

  &:focus {
    outline: none;
  }
`;

const primary = css`
  background: ${theme.primary600};
  color: #fff;

  &:hover {
    background: ${theme.background};
    border-color: ${theme.primary600};
    color: ${theme.primary600};
  }
`;

const primaryLight = css`
  background: transparent;
  color: ${theme.primary600};
  border-color: ${theme.primary600};

  &:hover {
    background: ${theme.primary600};
    border-color: ${theme.primary600};
    color: #fff;
  }
`;

const text = css`
  background: transparent;
  color: ${theme.body.color};

  &:hover {
    text-decoration: underline;
  }
`;

const ButtonEl = styled.button`
  ${baseStyles};
  ${p => {
    switch (p.type) {
      case 'primary':
        return primary;
      case 'text':
        return text;
    }
  }}
`;

const ButtonLink = styled.a`
  ${baseStyles};
  ${p => {
    switch (p.type) {
      case 'primary':
        return primary;
      case 'primaryLight':
        return primaryLight;
      case 'text':
        return text;
    }
  }}
`;

export default function Button({
  children,
  href,
  onClick,
  style = {},
  type = 'primary',
  target = '_parent',
}) {
  if (!!href && !onClick) {
    return (
      <ButtonLink href={href} style={style} type={type} target={target}>
        {children}
      </ButtonLink>
    );
  }
  return (
    <ButtonEl onClick={onClick} style={style} type={type}>
      {children}
    </ButtonEl>
  );
}
